import {
  RouteIASDashboard,
  RouteIASGlossary,
  RouteIASHelp,
  RouteReportBuilderList,
  RouteReportsDashboard,
} from '~/src/dash/router/routes';
import {
  INavBarConfig,
  INavBarSingleRow,
  NavBarItemLabels,
} from '~/src/dash/views/navbar/configs/defaultCfg';

export const iasWhiteLabelConfig = {
  sections: {
    Main: {
      label: 'Main',
      isLabelDisplayed: false,
      items: [
        {
          label: NavBarItemLabels.DASHBOARDS,
          iconPath: '/assets/shared/svg/navbar/Dashboards16.svg',
          iconPathDark: '/assets/shared/svg/navbar/black/Dashboards16.svg',
          eventName: 'Sidebar - IAS Dashboard',
          route: RouteIASDashboard,
        },
        {
          isSubMenu: true,
          label: NavBarItemLabels.REPORTING,
          iconPath: '/assets/shared/svg/navbar/Reporting16.svg',
          iconPathDark: '/assets/shared/svg/navbar/black/Reporting16.svg',
          subViews: ['reports-dashboard', 'report-builder'],
          subItems: [
            {
              label: NavBarItemLabels.REPORTSDASHBOARD,
              eventName: 'Sidebar - Reports Dashboard',
              route: RouteReportsDashboard,
              pathString: 'iasreporting',
              permChecks: ['read_report', 'write_report'],
              customActiveCheck: (pathname) =>
                pathname.indexOf('iasreporting') > -1 && pathname.indexOf('reports-dashboard') > -1,
            },
            {
              label: NavBarItemLabels.REPORTBUILDER,
              eventName: 'Sidebar - Report Builder',
              route: RouteReportBuilderList,
              pathString: 'iasreporting',
              permChecks: ['read_report', 'write_report'],
              customActiveCheck: (pathname) =>
                pathname.indexOf('iasreporting') > -1 && pathname.indexOf('report-builder') > -1,
            },
          ],
        },
      ] as INavBarSingleRow[],
    },
    Miscellaneous: {
      label: 'Miscellaneous',
      isLabelDisplayed: false,
      items: [
        {
          isSubMenu: true,
          label: NavBarItemLabels.REFERENCES,
          iconPath: '/assets/shared/svg/Reference.svg',
          iconPathDark: '/assets/shared/svg/Reference_black.svg',
          subViews: ['glossary', 'context-control'],
          subItems: [
            {
              label: NavBarItemLabels.GLOSSARY,
              eventName: 'Sidebar - IAS Glossary',
              route: RouteIASGlossary,
              pathString: 'reference',
              customActiveCheck: (pathname) =>
                pathname.indexOf('reference') > -1 && pathname.indexOf('iasglossary') > -1,
            },
          ],
        },
        {
          label: NavBarItemLabels.HELP,
          iconPath: '/assets/shared/svg/Help.svg',
          iconPathDark: '/assets/shared/svg/Help_black.svg',
          eventName: 'Sidebar - IAS Help',
          isExternalRoute: true,
          route: RouteIASHelp,
        },
      ],
    },
  },
} as INavBarConfig;
